import React, { useEffect } from "react";
import Prism from "prismjs";
import "prismjs/components/prism-yaml";
import "./Code.css";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.js";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { darcula } from "react-syntax-highlighter/dist/esm/styles/hljs";

interface Props {
  code: string;
}

export default function Code({ code }: Props) {
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  return (
    <SyntaxHighlighter language="yaml" wrapLines={true} style={darcula}>
      {code}
    </SyntaxHighlighter>
  );
}
